import css from 'styled-jsx/css';
import { grayBackground } from 'styles/css-constants';

/*
Overview
--------
Soundbar displays from 1 item in a prominent, featured way. The layout accounts for a single ad item to be rendered after the item.
*/
export default css`
  .Spread--spotlight {
    width: 100vw;
    padding: 1.5rem 0 0;
    background-color: ${grayBackground};
  }

  .Spread__description {
    display: none;
  }

  .Spread__item--ad {
    padding: 1.5rem 0.5rem;
    margin-right: -0.5rem;
    margin-left: -0.5rem;
    background-color: #fff;
  }

  .Spread__item--teaser,
  .Spread__item--teaser :global(a) {
    display: flex;
  }

  .Spread__item--teaser {
    margin-bottom: 1.5rem;
  }

  .Spread__items {
    padding: 0 0.5rem;
  }

  .Spread__title {
    margin-bottom: 1.5rem;
  }

  .Spread__title h4 {
    margin-right: 0;
  }

  @media (min-width: 48rem) {
    .Spread--spotlight {
      padding: 3rem 0 0;
    }

    .Spread__items {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    .Spread__item--ad {
      margin-right: 0;
      margin-left: 0;
      flex: 0 0 100%;
      max-width: 100%;
      padding: 0;
    }

    .Spread__item--ad:not(:last-child) {
      margin-bottom: 0;
    }

    .Spread__item--teaser {
      flex: 0 0 33.33%;
      margin-bottom: 2.5rem;
      max-width: 33.33%;
      padding: 0 0.75rem;
    }

    .Spread__title {
      text-align: center;
    }
  }

  @media (min-width: 64rem) {
    .Spread__items {
      padding: 0;
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) {
      .Spread--spotlight {
        grid-template:
          '........... title       ...........'
          'description description description'
          'items items items'
          / 1fr auto 1fr;
        width: 100%;
      }

      .Spread--spotlight :global(.Ad > div) {
        margin-top: 3rem;
      }

      .Spread__item--ad {
        grid-column: span 5;
      }

      .Spread__item--teaser {
        max-width: none;
        padding: 0;
      }

      .Spread__item--teaser:nth-child(4n + 1) {
        grid-column-start: 2;
      }

      .Spread__items {
        grid-template-columns: 0px repeat(3, 1fr) 0px;
        grid-gap: 1.5rem;
        padding: 0;
      }

      .Spread__link,
      .Spread__title {
        margin-right: 0;
        margin-left: 0;
      }

      .Spread__link {
        justify-self: initial;
        align-items: initial;
      }

      .Spread__title {
        text-align: center;
      }
    }

    @media (min-width: 64rem) {
      .Spread__items {
        grid-template-columns: 1fr repeat(3, 309.33px) 1fr;
      }
    }

    @media (min-width: 75rem) {
      .Spread__items {
        grid-template-columns: 1fr repeat(3, 366.67px) 1fr;
      }
    }
  }
`;
